import { platformGraph } from "@/api/platform-graph";
import { unwrapEnvelope, type EnvelopedFetchResult } from "@/api/errors";

export type SetupStep = "company" | "companies" | "locations" | "departments" | "branding" | "identity" | "admins" | "review";
export interface SetupProgress {
  readonly version: 1;
  readonly revision: number;
  readonly confirmed: number;
  readonly current_step: SetupStep;
  readonly auto_launch: boolean;
  readonly completed_at: string | null;
}
export interface AdminSetup {
  readonly progress: SetupProgress;
  readonly company_name: string;
  readonly summary: { readonly users: number; readonly seats: number; readonly active_integrations: number };
  readonly steps: readonly { readonly id: SetupStep; readonly ready: boolean; readonly completed: boolean; readonly accessible: boolean }[];
}
export interface SetupCommand {
  readonly action: "visit" | "confirm";
  readonly step_id: SetupStep;
  readonly expected_revision: number;
}
export const setupQueryKey = ["admin", "setup"] as const;

type SetupGet = (path: "/v1/admin/setup") => Promise<EnvelopedFetchResult<{ setup: AdminSetup }>>;
export async function fetchAdminSetup(): Promise<AdminSetup> {
  return (await unwrapEnvelope((platformGraph.GET as unknown as SetupGet)("/v1/admin/setup"))).setup;
}

type SetupPost = (path: "/v1/admin/setup/progress", init: { body: SetupCommand; headers: Record<string, string> }) => Promise<EnvelopedFetchResult<{ progress: SetupProgress }>>;
export async function saveSetupProgress(command: SetupCommand, idempotencyKey: string): Promise<SetupProgress> {
  return (await unwrapEnvelope((platformGraph.POST as unknown as SetupPost)("/v1/admin/setup/progress", {
    body: command, headers: { "x-idempotency-key": idempotencyKey },
  }))).progress;
}
